export default "/images/vendor/flag-icon-css/flags/4x3/ni.svg?97abb7cd7189b26408f985fb372e2391";